import MiLoader from './MiLoader.vue'

export default MiLoader
